export default "__VITE_ASSET__KAOPTwrX__"